// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './visual-refresh.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n'; // Initialize i18next configuration

const root = createRoot(document.getElementById('root'));

// NOTE: Avoid React.StrictMode here to prevent double-mount effect loops in dev
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
